import { property, curry, omit, isEmpty } from 'lodash-es';
import { compose } from 'redux';
import { jsonApi, rest, core } from '@updater/redux-http-request';
import { requestUpdRestApi } from './rest';
import { find } from '../utils';

export const reducer = decorateJsonApiReducer(jsonApi.reducer);
export const selectors = jsonApi.selectors(property('jsonApi'));
export const utils = jsonApi.utils;

const requestUpdJsonApi = compose(
  jsonApi.request,
  requestUpdRestApi
);

export const findResource = curry((collection, fn, state) =>
  compose(
    find(fn),
    collection
  )(state)
);

export const createUpdResourceFacade = resource =>
  rest.createResourceFacade(resource, requestUpdJsonApi);

// TODO: Remove once redux-http-request handles DELETE
const { isRequestResultSuccessFor, isDelete, isUrlPattern } = core.matchers;
function decorateJsonApiReducer(originalReducer) {
  return (state, action) => {
    const hasNoPayload = compose(
      isEmpty,
      property('payload.data')
    );

    // Temporary solution for removing a successfully deleted resource from the
    // jsonApi store. Exception: if the DELETE response contains a json-api
    // payload, treat it like an update.
    if (isRequestResultSuccessFor(isDelete)(action) && hasNoPayload(action)) {
      const resource = property('meta.request.meta.rest.resource')(action);
      const { resources } = state;
      return {
        ...state,
        resources: {
          ...resources,
          [resource.name]: omit(resources[resource.name], resource.id),
        },
      };
    } else if (isRequestResultSuccessFor(isUrlPattern('v2/sessions'))(action)) {
      const { resources } = state;
      return originalReducer(
        {
          ...state,
          resources: {
            ...resources,
            // Clean out any existing `item_definitions` before merging in the
            // ones coming back in `sessions`. Cleaning is necessary b/c item
            // definitions may already exist from the `site-config` response,
            // which could be a different set than that of `sessions`.
            // See bug for more details:
            // https://app.clubhouse.io/updater/story/19846/new-step-showing-on-entity-that-excluded-it
            item_definitions: {},
          },
        },
        action
      );
    } else {
      return originalReducer(state, action);
    }
  };
}
